import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    layout: {
      textAlign: 'left',
      fontSize: '14px',
      display: 'flex',
      padding: '30px 41px 0px 41px',
      //   border: '2px solid red',
      alignItems: 'center',
    },
    elementlayout: {
      display: 'flex',
      alignItems: 'center',
      justifContent: 'space-between',
    },
  }),
  { index: 1 },
)

export { useStyles }
